// ---------------------------------------------------------------------------
// Autocomplete event registry + config
//
// One source of truth for every event name and tunable used by the Nosto
// autocomplete pipeline. Reference these constants instead of string literals
// so typos crash at load time, not silently at runtime.
//
// Naming convention:
//   autocomplete:<layer>:<subject>:<verb>
//     layer   = ui | api | state
//     subject = query, active-term, response, ...
//     verb    = updated, fetched, failed, ...
// ---------------------------------------------------------------------------

window.theme = window.theme || {}
window.theme.autocomplete = window.theme.autocomplete || {}

window.theme.autocomplete.events = {
  // UI intents — published by components, consumed by the state layer
  UI: {
    QUERY_UPDATED: 'autocomplete:ui:query:updated',
  },

  // API layer — fetch requests in, results out
  API: {
    ACTIVE_TERM_UPDATED: 'autocomplete:api:active-term:updated',
    QUERY_FETCHED: 'autocomplete:api:query:fetched',
    FETCH_FAILED: 'autocomplete:api:fetch:failed',
  },

  // State layer broadcasts — consumed by components
  STATE: {
    RESPONSE_UPDATED: 'autocomplete:state:response:updated',
  },
  TRACKING: {
    PRODUCT_CLICKED: 'autocomplete:tracking:product:clicked',
    PRODUCT_ADDED_TO_CART: 'autocomplete:tracking:product:added-to-cart',
    KEYWORD_CLICKED: 'autocomplete:tracking:keyword:clicked',
  },
}

window.theme.autocomplete.config = {
  productSize: 6,
  categorySize: 5,
  keywordSize: 6,
  popularSearchSize: 5,
  debounceMs: 250,
}
